//#region libraries
import React from 'react';
// table
import {
    Card,
    Table,
    TableHead,
    TableRow,
    TableHeaderCell,
    TableBody,
    TableCell,
    Text
} from "@tremor/react";
//#endregion

const BookingTable = (props) => {
    return (
        <Card maxWidth="max-w-lg">
            <Table>
                <TableHead>
                    <TableRow>
                        <TableHeaderCell>Passenger</TableHeaderCell>
                        <TableHeaderCell>Flight</TableHeaderCell>
                        {<TableHeaderCell>Date</TableHeaderCell>}
                        <TableHeaderCell>Origin</TableHeaderCell>
                        <TableHeaderCell>Destination</TableHeaderCell>
                        <TableHeaderCell>Time Created</TableHeaderCell>
                        <TableHeaderCell>Assistance</TableHeaderCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {props.data.map((item) => (
                        (!item || (item.error && item.error.length > 0)) ?
                            <TableRow>
                                <TableCell><Text>{item.booking && item.booking.name && item.booking.name}</Text></TableCell>
                                <TableCell><Text><p style={{ color: 'red', fontSize: 14, fontWeight: 'bold' }}>{item.error}</p></Text></TableCell>
                                {<TableCell>{'-'}</TableCell>}
                                <TableCell><Text>{' - '}</Text></TableCell>
                                <TableCell><Text>{' - '}</Text></TableCell>
                                <TableCell><Text>{' - '}</Text></TableCell>
                                <TableCell><Text style={{ textTransform: 'uppercase' }}>{' - '}</Text></TableCell>
                            </TableRow>
                            :
                            <TableRow>
                                <TableCell><Text>{item.passenger.replace(/\b(\w)/g, s => s.toUpperCase())}</Text></TableCell>
                                <TableCell><Text>{item.flight}</Text></TableCell>
                                {<TableCell>{item.date}</TableCell>}
                                <TableCell><Text>{item.origin}</Text></TableCell>
                                <TableCell><Text>{item.destination}</Text></TableCell>
                                <TableCell><Text>{new Date(item.timeCreated) != 'Invalid Date' ? new Date(item.timeCreated).toLocaleTimeString().substring(0, 5) + ' ' + new Date(item.timeCreated).toLocaleDateString() : ''}</Text></TableCell>
                                <TableCell><Text style={{ textTransform: 'uppercase' }}>{item.assistance}</Text></TableCell>
                            </TableRow>
                    ))}
                </TableBody>
            </Table>

        </Card>
    );
};

export default BookingTable;